import { ReactNode } from "react";

interface SectionProps {
  title: string;
  children: ReactNode;
}

const Section = ({ title, children }: SectionProps) => (
  <div className="flex flex-col gap-3">
    <h1 className="text-purple-primary text-lg font-semibold">{title}</h1>
    {children}
  </div>
);

export default Section;
